<template>
  <el-dialog
    title="选择卡片设计"
    :visible.sync="dialogVisible"
    @close="closeDialog"
    width="80%"
    class="card-design-dialog"
  >
    <div class="design-container">
      <!-- 左侧卡片选择 -->
      <div class="card-list-section">
        <div class="section-title">卡片背景样式</div>
        <div class="card-grid" v-loading="loading">
          <div
            v-for="(card, index) in cardList"
            :key="index"
            :class="['card-item', { active: selectedCard && selectedCard.image_path === card.image_path }]"
            @click="selectCard(card)"
          >
            <div class="card-preview">
              <img :src="card.image_url" :alt="`卡片背景${index + 1}`" />
            </div>
            <div class="card-overlay">
              <i class="el-icon-check" v-if="selectedCard && selectedCard.image_path === card.image_path"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧卡片预览 -->
      <div class="preview-section">
        <div class="section-title">预览效果</div>
        <div class="gift-card-preview" :style="previewCardStyle">
          <div class="card-header">
            <span class="card-title">礼品卡</span>
            <span class="card-price">${{ formData.price || '0.00' }}</span>
          </div>
          <div class="card-name">{{ formData.name || '礼品卡名称' }}</div>
          <div class="card-scope">所有服务和产品</div>
          <div class="card-footer">
            <div class="card-logo">
              <div class="logo-circle"></div>
              <span>Exq Spa</span>
            </div>
            <div class="card-expiry">
              <span>有效期至</span>
              <span>{{ expiryText }}</span>
            </div>
          </div>
        </div>
        
        <div class="preview-tips" v-if="!selectedCard">
          <p>请选择左侧的卡片背景样式查看预览效果</p>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="confirmSelection" :disabled="!selectedCard">确 定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import GiftCardApi from '@/api/gift_card/gift_card.js';

export default {
  name: 'CardDesignSelector',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentCard: {
      type: Object,
      default: null
    },
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      cardList: [],
      selectedCard: null
    };
  },
  computed: {
    previewCardStyle() {
      if (this.selectedCard) {
        return {
          backgroundImage: `url(${this.selectedCard.image_url})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        };
      }
      return {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      };
    },
    expiryText() {
      const days = this.formData.expiration_days || 0;
      if (days === 0) {
        return '永不结束';
      }
      const months = Math.round(days / 30);
      return `购买后 ${months} 个月`;
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal;
      if (newVal) {
        this.loadCardList();
        this.selectedCard = this.currentCard;
      }
    }
  },
  methods: {
    /**
     * 加载卡片背景列表
     */
    loadCardList() {
      this.loading = true;
      GiftCardApi.getCardImageList({}, true)
        .then(data => {
          this.loading = false;
          this.cardList = data.data.list || [];
        })
        .catch(error => {
          this.loading = false;
          this.$message.error('获取卡片背景列表失败');
          console.error('获取卡片背景失败:', error);
        });
    },

    /**
     * 选择卡片
     */
    selectCard(card) {
      this.selectedCard = card;
    },

    /**
     * 确认选择
     */
    confirmSelection() {
      if (this.selectedCard) {
        this.$emit('select', this.selectedCard);
        this.closeDialog();
      }
    },

    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style scoped>
.card-design-dialog {
  max-width: 1000px;
}

.design-container {
  display: flex;
  gap: 30px;
  min-height: 500px;
}

.card-list-section {
  flex: 1;
}

.preview-section {
  flex: 1;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 15px;
  max-height: 400px;
  overflow-y: auto;
}

.card-item {
  position: relative;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.card-item:hover {
  border-color: #409eff;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.card-item.active {
  border-color: #409eff;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.card-preview {
  width: 100%;
  height: 100px;
  position: relative;
}

.card-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(64, 158, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.card-item.active .card-overlay {
  opacity: 1;
}

.card-overlay .el-icon-check {
  color: white;
  font-size: 24px;
}

.gift-card-preview {
  width: 100%;
  height: 200px;
  border-radius: 12px;
  padding: 20px;
  color: white;
  position: relative;
  margin-bottom: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.card-title {
  font-size: 16px;
  font-weight: 500;
}

.card-price {
  font-size: 24px;
  font-weight: bold;
}

.card-name {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
}

.card-scope {
  font-size: 14px;
  opacity: 0.9;
  margin-bottom: 30px;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  position: absolute;
  bottom: 20px;
  left: 20px;
  right: 20px;
}

.card-logo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
}

.card-expiry {
  text-align: right;
  font-size: 12px;
}

.preview-tips {
  text-align: center;
  color: #999;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}

.dialog-footer {
  text-align: right;
}

/* 滚动条样式 */
.card-grid::-webkit-scrollbar {
  width: 6px;
}

.card-grid::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.card-grid::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.card-grid::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style> 


// WEBPACK FOOTER //
// src/views/gift_card/gift_card/CardDesignSelector.vue